import * as z from 'zod/v4';

import { type Currency, currencySchema } from '../lib/entry.js';
import { productSchema } from '../product/entry.js';
import { drawNumberSchema } from './DrawNumber.js';

const fundBaseSchema = z.object({
  rolloverIn: currencySchema,
  extraMoney: currencySchema,
});

export const fundSchema = z.object({
  ...fundBaseSchema.shape,
  drawNumber: drawNumberSchema,
  product: productSchema,
});

/**
 * TS type for fund type
 */
export type Fund = z.infer<typeof fundSchema> & {
  jackpot?: Currency;
  guaranteeJackpot?: Currency;
};

/**
 * Zod schema for Fund entity
 */
export const fundsTransformSchema = fundBaseSchema.transform((fund) => {
  return fund;
});
